import React from 'react';
import { Box, Stack } from '@mui/material';
import { LocationOnOutlined } from '@mui/icons-material';
import { SectionHeader, SectionPaper } from '../../../../common/components/styled-ui-elements';
import {
  CenterEdit,
  BuildingEdit,
  FloorEdit,
  RoomEdit,
} from '../fields';

/**
 * LocationSection - Asset location fields
 * Contains center, building, floor, and room
 */
export const LocationSection: React.FC = () => {
  return (
    <Box>
      <SectionHeader
        icon={<LocationOnOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Location"
      />
      <SectionPaper>
        <Stack direction="row" gap={2}>
          <CenterEdit />
          <BuildingEdit />
          <FloorEdit />
          <RoomEdit />
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default LocationSection;
